import './PitcherSingleSessionPitchTypeRangesChart.scss';

import { PitchTypeRangesChartConfigDto, PitchTypeRangesChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import useReportStore from 'hooks/SessionReport/PitcherSingle/reportStore';
import PitchTypeRangesChart from 'components/Charts/PitchTypeRangesChart/PitchTypeRangesChart';

const PitcherSingleSessionPitchTypeRangesChart = (props: ChartProps<PitchTypeRangesChartDataDto, PitchTypeRangesChartConfigDto>) => {
  const { selectedConfgValues } = useReportStore();

  return (
    <div className='PitcherSingleSessionPitchTypeRangesChart-container'>
      <PitchTypeRangesChart {...props} pitchGrouping={selectedConfgValues.pitchGrouping} />
    </div>
  );
};

export default PitcherSingleSessionPitchTypeRangesChart;
